import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ReAssessmentButtonProps {
  id: number;
}

function ReAssessmentButton({ id }: ReAssessmentButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      onClick={() => {
        window.open(
          `/app/assessment-results/${id}?isFirstTime=false`,
          "_blank",
        );
      }}
    >
      {t("re-assessment-report")}
    </Button>
  );
}

export default ReAssessmentButton;
